import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	padding: 0 32px;
	border-bottom: 1px solid ${colors.grey2};
	align-items: center;
	min-height: 76px;
`;

export const StepCircle = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: ${colors.grey3};
	color: white;
	max-width: 28px;
	min-width: 28px;
	width: 28px;
	height: 28px;
`;

export const StepTitle = styled.div`
	font-size: 16px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	padding-left: 8px;
`;

export const StepWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 44px;
	padding: 0 8px;
	color: ${colors.grey4};

	&.active {
		cursor: pointer;
		color: ${colors.grey8};

		${StepCircle} {
			background-color: ${colors.green1};
		}
	}
`;

export const Conector = styled.div`
	display: flex;
	border-bottom: 1px solid ${colors.grey2};
	flex: 1;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: black;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin-left: auto;
`;
